import { Pipe, PipeTransform } from '@angular/core';
import { Image } from '@frontend/core';
import { ImageUrlService, ImageUrlSource } from '@frontend/common';

/**
 * Renders any image to a delivery URL, e.g.
 *   `<img [src]="hero | imageUrl:'w_1600,c_fill,ar_16:9'" [alt]="hero?.alt_text">`
 * or in a background:
 *   `[style.background-image]="'url(' + (img | imageUrl) + ')'"`.
 *
 * Accepts a full {@link Image} or a bare `{disk, path}` (e.g. a user avatar's
 * `avatar_disk` / `avatar_path`). Returns `null` when there is no image — the call
 * site decides its own fallback. See {@link ImageUrlService} for URL semantics.
 *
 * Lives in `@frontend/shared` (not `@frontend/common`) so it can be imported into
 * both shared and common component modules — a standalone declarable from `common`
 * cannot be imported into a `shared` NgModule (barrel cycle). The URL-building logic
 * stays in `ImageUrlService` (in `common`), reached here via DI, which does work
 * across the cycle.
 */
@Pipe({
  name: 'imageUrl',
  standalone: true,
})
export class ImageUrlPipe implements PipeTransform {
  constructor(private imageUrlService: ImageUrlService) {}

  transform(
    image: ImageUrlSource | Image | null | undefined,
    transform?: string
  ): string | null {
    return this.imageUrlService.build(image, transform);
  }
}
